import React from "react";

export function SvgIconUser() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="53"
      height="46px"
      viewBox="0 0 26.5 23"
      enableBackground="new 0 0 26.5 23"
    >
      <path
        fill="#666766"
        d="M3.4,7.7c0,2.6,2.2,4.7,4.8,4.7c2.7,0,4.8-2.1,4.8-4.7c0-2.6-2.2-4.7-4.8-4.7C5.6,2.9,3.4,5,3.4,7.7z M10.7,7.7c0,1.3-1.1,2.4-2.5,2.4c-1.4,0-2.5-1.1-2.5-2.4c0-1.3,1.1-2.4,2.5-2.4C9.6,5.2,10.7,6.3,10.7,7.7z"
      />
      <path
        fill="#666766"
        d="M26.3,16.9L26,14.4l0,0c-0.1-1-0.6-1.9-1.4-2.5l-0.1-0.1l0,0l0,0l0,0l0,0l0,0l-0.1-0.1c-0.7-0.6-1.7-1-2.7-1 h-6.5l-0.1,0c-0.3,0-0.6,0.1-0.9,0.1L14.1,11c-0.6,0.2-1.2,0.6-1.7,1l-0.1,0.1c-0.3,0.3-0.5,0.7-0.7,1.1l-0.1,0H4.9 c-2.1,0-3.9,1.6-4.2,3.6l0,0l-0.3,2.5l0,0l0,0.4c0,1.7,1.4,3.2,3.2,3.2l9,0l0,0c1.5,0,2.8-1,3.1-2.4l7.3,0c1.8,0,3.2-1.5,3.2-3.2 L26.3,16.9L26.3,16.9z M14.1,13.6l0.2-0.1l0.4-0.2l0.1-0.1c0.2-0.1,0.4-0.1,0.6-0.1h6.5c0.9,0,1.7,0.7,1.8,1.6l0.3,2.5l0,0l0,0.1 c0,0.5-0.4,0.8-0.9,0.8l-7.4,0l-0.1-1.4l0,0c-0.2-1.2-0.8-2.2-1.8-2.8l0,0L14.1,13.6z M12.7,20.7L12.7,20.7l-9,0 c-0.5,0-0.9-0.4-0.9-0.9l0-0.1l0,0l0.3-2.5c0.1-0.9,0.9-1.6,1.8-1.6h6.5c0.9,0,1.7,0.7,1.8,1.6l0.3,2.5l0,0l0,0.1 C13.5,20.3,13.2,20.7,12.7,20.7z"
      />
      <path
        fill="#666766"
        d="M25.4,3L25.4,3L25.4,3c0-1.4-1.2-2.5-2.6-2.5l0,0c-0.7,0-1.3,0.3-1.7,0.7c-0.7-0.4-1.6-0.7-2.5-0.7l0,0l0,0 c-2.7,0-4.8,2.1-4.8,4.7c0,2.6,2.2,4.7,4.8,4.7h0l0,0c2.2,0,4-1.5,4.6-3.4c0.3,0.5,0.9,0.9,1.5,1.2C25.3,7.9,26,7.6,26.2,7 c0.2-0.6-0.1-1.3-0.7-1.5c-0.3-0.1-0.3-0.2-0.3-0.2c0,0-0.1-0.1-0.1-0.3c0-0.2,0-0.5,0.1-0.8C25.3,3.8,25.4,3.5,25.4,3z M16.2,5.2 c0-1.3,1.1-2.4,2.4-2.4c1.4,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.5,2.4C17.3,7.6,16.2,6.6,16.2,5.2z M22.8,2.9L22.8,2.9L22.8,2.9 L23.1,3l0,0.3C23,3.2,22.9,3,22.8,2.9z"
      />
    </svg>
  );
}

export function SvgIconUsers() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="32px"
      height="41px"
      viewBox="0 0 16 20.5"
      enableBackground="new 0 0 16 20.5"
    >
      <path
        fill="#666766"
        d="M3.1,4.8c0,2.7,2.2,4.8,4.9,4.8c2.7,0,4.9-2.2,4.9-4.8C12.8,2.1,10.7,0,8,0C5.3,0,3.1,2.1,3.1,4.8z M10.5,4.8c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5C9.4,2.4,10.5,3.5,10.5,4.8z"
      />
      <path
        fill="#666766"
        d="M11.2,10.5H4.6c-2.1,0-3.9,1.6-4.1,3.7l0,0l-0.3,2.6h0l0,0.4c0,1.8,1.4,3.2,3.3,3.2l9.1,0l0,0 c1.5,0,2.8-1.1,3.1-2.5l-0.1-2.4l-0.1-1.4l0,0c-0.2-1.2-0.9-2.2-1.8-2.9C13,10.8,12.4,10.5,11.2,10.5z M12.5,18.1L12.5,18.1l-9.1,0 c-0.5,0-0.9-0.4-0.9-0.9l0-0.1l0,0l0.3-2.6c0.1-0.9,0.9-1.6,1.9-1.6h6.6c0.9,0,1.7,0.7,1.8,1.6l0.3,2.6l0,0l0,0.1 C13.4,17.7,13,18.1,12.5,18.1z"
      />
    </svg>
  );
}

export function SvgIconCalendar() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="45px"
      height="45px"
      viewBox="0 0 22.5 22.5"
      enableBackground="new 0 0 22.5 22.5"
    >
      <path
        fill="#666766"
        d="M18.3,1.9h-0.9V1.4c0-0.7-0.6-1.4-1.3-1.4s-1.3,0.6-1.3,1.4v0.5H8V1.4C8,0.6,7.4,0,6.6,0S5.3,0.6,5.3,1.4 v0.5H4.4c-2.2,0-4,1.8-4,4.1v12.5c0,2.2,1.8,4.1,4,4.1h13.9c2.2,0,4-1.8,4-4.1V5.9C22.4,3.7,20.6,1.9,18.3,1.9z M4.2,4.5h0.9v1.2 c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4V4.5h7v1.2c0,0.8,0.6,1.4,1.4,1.4s1.4-0.6,1.4-1.4V4.5h0.9c0.8,0,1.4,0.6,1.4,1.4v2.8H2.8 V5.9C2.8,5.1,3.4,4.5,4.2,4.5L4.2,4.5z M18.6,19.9H4.2c-0.8,0-1.4-0.6-1.4-1.4v-7.3H20v7.3C20,19.3,19.3,19.9,18.6,19.9z"
      />
    </svg>
  );
}

export function SvgIconTime() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40px"
      height="61px"
      viewBox="0 0 20 30.5"
      enableBackground="new 0 0 20 30.5"
    >
      <path
        fill="#666766"
        d="M7.3,27.7C7.4,27.7,7.4,27.7,7.3,27.7l5.4,0c0,0,0,0,0,0c0.5,0,0.9-0.4,0.9-0.9c0-0.2-0.1-0.5-0.3-0.6 C13.2,26.1,13,26,12.7,26H7.4c0,0-0.1,0-0.1,0l0,0c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.2,0.4-0.2,0.6c0,0.2,0.1,0.5,0.3,0.6 C6.9,27.6,7.1,27.7,7.3,27.7z M7.3,26.2L7.3,26.2L7.3,26.2L7.3,26.2z"
      />
      <path
        fill="#666766"
        d="M10.1,20.5c2.9,0,5.3-2.4,5.3-5.3S13,10,10.1,10s-5.3,2.4-5.3,5.3S7.1,20.5,10.1,20.5z M10.1,11.8 c1.9,0,3.5,1.5,3.5,3.4s-1.6,3.4-3.5,3.4s-3.5-1.5-3.5-3.4S8.1,11.8,10.1,11.8z"
      />
      <path
        fill="#666766"
        d="M10.1,2.6C9.5,2.6,9,3.1,9,3.7c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1C11.1,3.1,10.6,2.6,10.1,2.6z"
      />
      <path
        fill="#666766"
        d="M13.8,0H6.3c-3.3,0-6,2.8-6,6.2v17.9c0,0.1,0,0.1,0,0.2c0.1,3.5,2.7,6.2,6,6.2h7.5c3.3,0,6-2.8,6-6.3v-18 C19.7,2.8,17.1,0,13.8,0z M17.6,25.2c-0.4,1.9-2,3.3-3.9,3.3H6.3c-1.9,0-3.4-1.4-3.9-3.3H17.6z M2.5,5.3C2.9,3.4,4.5,2,6.3,2h7.5 c1.9,0,3.4,1.4,3.9,3.3H2.5z M17.8,7.3v15.8H2.3V7.3H17.8z M0.6,6.3L0.6,6.3L0.6,6.3L0.6,6.3z"
      />
      <path
        fill="#666766"
        d="M10.1,16.6h1.6h0c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6 c-0.1-0.2-0.3-0.2-0.6-0.2h-0.8v-1.4c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.3-0.2-0.6-0.2c0,0-0.1,0-0.1,0c-0.4,0-0.7,0.4-0.7,0.8v2.2 C9.3,16.2,9.6,16.6,10.1,16.6z"
      />
    </svg>
  );
}

export function SvgIconMapPointer() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="53px"
      height="45px"
      viewBox="0 0 26.5 22.5"
      enableBackground="new 0 0 26.5 22.5"
    >
      <path
        fill="#666766"
        d="M12.5,12.1c2.3,0,4.2-1.9,4.2-4.2c0-2.3-1.9-4.2-4.2-4.2S8.3,5.7,8.3,8C8.3,10.3,10.2,12.1,12.5,12.1z M10.1,8c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4s-1.1,2.4-2.4,2.4S10.1,9.3,10.1,8z"
      />
      <path
        fill="#666766"
        d="M26.3,21.4l-3.2-11.1c0-0.1-0.1-0.3-0.2-0.4c0,0-0.1-0.1-0.1-0.1l-0.1-0.1h0c-0.1-0.1-0.2-0.1-0.3-0.1 c0,0-0.1,0-0.1,0c-1.3,0-2.1,0-2.6,0C19.9,8.9,20,8.4,20,7.8c0-2.2-0.8-4.2-2.4-5.5c-1.3-1.2-3.2-1.8-5.1-1.8c0,0,0,0,0,0 c-1.9,0-3.8,0.7-5.1,1.8C5.8,3.6,5,5.6,5,7.8C5,8.4,5.1,9,5.2,9.6H4.6c-0.3,0-0.6,0.2-0.7,0.6L0.5,21.3c-0.1,0.5,0.1,0.9,0.5,1.1 c0.1,0,0.2,0,0.3,0h0h24.3c0.4,0,0.8-0.4,0.8-0.9C26.4,21.5,26.4,21.4,26.3,21.4z M24.5,20.7h-3l-2.7-2.4l5,0L24.5,20.7z M8.5,3.6 c1-0.9,2.5-1.4,4-1.4c0,0,0,0,0,0c1.5,0,2.9,0.5,3.9,1.4c1.2,1,1.8,2.4,1.8,4.2c0,2.5-1.9,5.5-5.7,9c-3.8-3.5-5.8-6.5-5.8-9 C6.8,6,7.3,4.6,8.5,3.6z M18.6,12.5c0.2-0.4,0.5-0.8,0.6-1.3l2.6,0l0.3,1.2L18.6,12.5z M17.4,14.3l5.3,0l0.7,2.3h-6.4l-0.8-0.8 C16.5,15.3,16.9,14.8,17.4,14.3L17.4,14.3z M6.5,12.6l-1.7,0l0.4-1.3h0.7C6,11.8,6.3,12.2,6.5,12.6z M8.6,15.4l-2,1.7l-1.2-1.6 c-0.1-0.2-0.3-0.3-0.5-0.3c-0.2,0-0.4,0.1-0.6,0.2l-0.4,0.4l0.4-1.4l3.5,0C8,14.7,8.3,15.1,8.6,15.4z M7,19.1l2.8-2.4 c0.7,0.7,1.4,1.3,2,1.9c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0.1,0c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2 c0.6-0.5,1.2-1,1.8-1.6l1.1,1.1c0,0,0.1,0.1,0.1,0.1l2.9,2.6H2.4l0.6-1.8l1.7-1.6l1.2,1.6c0.1,0.2,0.3,0.3,0.5,0.3 C6.6,19.3,6.8,19.2,7,19.1z"
      />
    </svg>
  );
}

export function SvgIconStethoscope() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="43px"
      height="48px"
      viewBox="0 0 21.5 24"
      enableBackground="new 0 0 21.5 24"
    >
      <path
        fill="#666766"
        d="M21.4,13.8c0-1.8-1.5-3.4-3.3-3.4s-3.3,1.5-3.3,3.4c0,1.5,1,2.8,2.4,3.2c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0v0.5 c0,2.5-1.9,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4v-0.6c3.6-0.5,6.3-3.6,6.3-7.4V2.3c0-0.5-0.4-0.9-0.9-0.9h-1.5c0-0.5-0.4-0.9-0.9-0.9 c0,0-0.1,0-0.1,0c-0.5,0.1-0.8,0.5-0.8,0.9v1.8c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0,0,0,0,0,0H13v6.5 c0,3.1-2.4,5.6-5.4,5.6s-5.4-2.5-5.4-5.6V3.3h0.6c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0,0,0,0,0,0V1.4 c0-0.5-0.4-0.9-0.9-0.9c0,0,0,0,0,0c0,0-0.1,0-0.1,0C3.1,0.5,2.8,0.9,2.8,1.4H1.3c0,0-0.1,0-0.1,0c-0.5,0-0.8,0.4-0.8,0.9v7.4 c0,3.8,2.7,6.9,6.3,7.4v0.6c0,3.5,2.8,6.3,6.2,6.3c3.4,0,6.2-2.8,6.2-6.3v-0.5c0-0.1,0-0.2,0-0.2C20.3,16.6,21.4,15.3,21.4,13.8z M5.2,19.3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S6.1,19.3,5.2,19.3z"
      />
    </svg>
  );
}

export function SvgIconDefaultArrow() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="19px"
      height="32px"
      viewBox="0 0 9.5 16"
      enableBackground="new 0 0 9.5 16"
    >
      <path
        fill="#FFFFFF"
        d="M0.824,3C2.812,5.016,4.801,7.032,6.79,9.048c0-0.713,0-1.426,0-2.139c-1.989,2.016-3.977,4.032-5.966,6.048 c-1.359,1.378,0.75,3.518,2.109,2.139c1.988-2.016,3.977-4.032,5.966-6.048c0.569-0.578,0.571-1.56,0-2.139 C6.91,4.893,4.921,2.877,2.933,0.861C1.574-0.517-0.536,1.621,0.824,3L0.824,3z"
      />
    </svg>
  );
}

export function SvgIconCheck() {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="12.5px"
      height="9px"
      viewBox="0 0 12.5 9"
      enableBackground="new 0 0 12.5 9"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M0.3,3.7l0.4-0.4c0.3-0.3,0.9-0.3,1.2,0l3.7,3.8C6,7.4,6,8,5.7,8.3 L5.3,8.7C4.9,9.1,4.4,9.1,4,8.7L0.3,5C-0.1,4.6-0.1,4.1,0.3,3.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFFFFF"
        d="M11.8,0.3l0.4,0.4c0.3,0.3,0.3,0.9,0,1.3L6,8.2 c-0.3,0.3-0.9,0.3-1.2,0L4.3,7.8C4,7.4,4,6.9,4.3,6.5l6.2-6.3C10.9-0.1,11.5-0.1,11.8,0.3z"
      />
    </svg>
  );
}

export function SvgIconLogoSnapchat() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="147.553 39.286 514.231 514.631"
    >
      <path
        d="M147.553 423.021v.023c.308 11.424.403 22.914 2.33 34.268 2.042 12.012 4.961 23.725 10.53 34.627 7.529 14.756 17.869 27.217 30.921 37.396 9.371 7.309 19.608 13.111 30.94 16.771 16.524 5.33 33.571 7.373 50.867 7.473 10.791.068 21.575.338 32.37.293 78.395-.33 156.792.566 235.189-.484 10.403-.141 20.636-1.41 30.846-3.277 19.569-3.582 36.864-11.932 51.661-25.133 17.245-15.381 28.88-34.205 34.132-56.924 3.437-14.85 4.297-29.916 4.444-45.035v-3.016c0-1.17-.445-256.892-.486-260.272-.115-9.285-.799-18.5-2.54-27.636-2.117-11.133-5.108-21.981-10.439-32.053-5.629-10.641-12.68-20.209-21.401-28.57-13.359-12.81-28.775-21.869-46.722-26.661-16.21-4.327-32.747-5.285-49.405-5.27-.027-.004-.09-.173-.094-.255H278.56c-.005.086-.008.172-.014.255-9.454.173-18.922.102-28.328 1.268-10.304 1.281-20.509 3.21-30.262 6.812-15.362 5.682-28.709 14.532-40.11 26.347-12.917 13.386-22.022 28.867-26.853 46.894-4.31 16.084-5.248 32.488-5.271 49.008"
        fill="#fffc00"
      />
      <path
        d="M407.001 473.488c-1.068 0-2.087-.039-2.862-.076-.615.053-1.25.076-1.886.076-22.437 0-37.439-10.607-50.678-19.973-9.489-6.703-18.438-13.031-28.922-14.775-5.149-.854-10.271-1.287-15.22-1.287-8.917 0-15.964 1.383-21.109 2.389-3.166.617-5.896 1.148-8.006 1.148-2.21 0-4.895-.49-6.014-4.311-.887-3.014-1.523-5.934-2.137-8.746-1.536-7.027-2.65-11.316-5.281-11.723-28.141-4.342-44.768-10.738-48.08-18.484a7.187 7.187 0 0 1-.584-2.443 4.518 4.518 0 0 1 3.777-4.711c22.348-3.68 42.219-15.492 59.064-35.119 13.049-15.195 19.457-29.713 20.145-31.316a2.85 2.85 0 0 1 .101-.217c3.247-6.588 3.893-12.281 1.926-16.916-3.626-8.551-15.635-12.361-23.58-14.882-1.976-.625-3.845-1.217-5.334-1.808-7.043-2.782-18.626-8.66-17.083-16.773 1.124-5.916 8.949-10.036 15.273-10.036 1.756 0 3.312.308 4.622.923 7.146 3.348 13.575 5.045 19.104 5.045 6.876 0 10.197-2.618 11-3.362a1170.709 1170.709 0 0 0-.679-11.262c-1.614-25.675-3.627-57.627 4.546-75.95 24.462-54.847 76.339-59.112 91.651-59.112a3909.561 3909.561 0 0 0 7.582-.071c15.354 0 67.339 4.27 91.816 59.15 8.173 18.335 6.158 50.314 4.539 76.016l-.076 1.23c-.222 3.49-.427 6.793-.6 9.995.756.696 3.795 3.096 9.978 3.339 5.271-.202 11.328-1.891 17.998-5.014 2.062-.968 4.345-1.169 5.895-1.169 2.343 0 4.727.456 6.714 1.285l.106.041c5.66 2.009 9.367 6.024 9.447 10.242.071 3.932-2.851 9.809-17.223 15.485-1.472.583-3.35 1.179-5.334 1.808-7.952 2.524-19.951 6.332-23.577 14.878-1.97 4.635-1.322 10.326 1.926 16.912.036.072.067.145.102.221 1 2.344 25.205 57.535 79.209 66.432a4.523 4.523 0 0 1 3.778 4.711 7.252 7.252 0 0 1-.598 2.465c-3.289 7.703-19.915 14.09-48.064 18.438-2.642.408-3.755 4.678-5.277 11.668-.63 2.887-1.271 5.717-2.146 8.691-.819 2.797-2.641 4.164-5.567 4.164h-.441c-1.905 0-4.604-.346-8.008-1.012-5.95-1.158-12.623-2.236-21.109-2.236-4.948 0-10.069.434-15.224 1.287-10.473 1.744-19.421 8.062-28.893 14.758-13.265 9.379-28.272 19.987-50.707 19.987"
        fill="#fff"
      />
      <path
        d="M408.336 124.235c14.455 0 64.231 3.883 87.688 56.472 7.724 17.317 5.744 48.686 4.156 73.885-.248 3.999-.494 7.875-.694 11.576l-.084 1.591 1.062 1.185c.429.476 4.444 4.672 13.374 5.017l.144.008.15-.003c5.904-.225 12.554-2.059 19.776-5.442 1.064-.498 2.48-.741 3.978-.741 1.707 0 3.521.321 5.017.951l.226.09c3.787 1.327 6.464 3.829 6.505 6.093.022 1.28-.935 5.891-14.359 11.194-1.312.518-3.039 1.069-5.041 1.7-8.736 2.774-21.934 6.96-26.376 17.427-2.501 5.896-1.816 12.854 2.034 20.678 1.584 3.697 26.52 59.865 82.631 69.111a2.487 2.487 0 0 1-.229.9c-.951 2.24-6.996 9.979-44.612 15.783-5.886.902-7.328 7.5-9 15.17-.604 2.746-1.218 5.518-2.062 8.381-.258.865-.306.914-1.233.914h-.442c-1.668 0-4.2-.346-7.135-.922-5.345-1.041-12.647-2.318-21.982-2.318-5.21 0-10.577.453-15.962 1.352-11.511 1.914-20.872 8.535-30.786 15.543-13.314 9.408-27.075 19.143-48.071 19.143-.917 0-1.812-.031-2.709-.076l-.236-.01-.237.018c-.515.045-1.034.068-1.564.068-20.993 0-34.76-9.732-48.068-19.143-9.916-7.008-19.282-13.629-30.791-15.543-5.38-.896-10.752-1.352-15.959-1.352-9.333 0-16.644 1.428-21.978 2.471-2.935.574-5.476 1.066-7.139 1.066-1.362 0-1.388-.08-1.676-1.064-.844-2.865-1.461-5.703-2.062-8.445-1.676-7.678-3.119-14.312-9.002-15.215-37.613-5.809-43.659-13.561-44.613-15.795a2.739 2.739 0 0 1-.231-.918c56.11-9.238 81.041-65.408 82.63-69.119 3.857-7.818 4.541-14.775 2.032-20.678-4.442-10.461-17.638-14.653-26.368-17.422-2.007-.635-3.735-1.187-5.048-1.705-11.336-4.479-14.823-8.991-14.305-11.725.601-3.153 6.067-6.359 10.837-6.359 1.072 0 2.012.173 2.707.498 7.747 3.631 14.819 5.472 21.022 5.472 9.751 0 14.091-4.537 14.557-5.055l1.057-1.182-.085-1.583c-.197-3.699-.44-7.574-.696-11.565-1.583-25.205-3.563-56.553 4.158-73.871 23.37-52.396 72.903-56.435 87.525-56.435.36 0 6.717-.065 6.717-.065.26-.002.549-.006.852-.006m0-9.038h-.017c-.333 0-.646 0-.944.004l-6.633.066c-8.566 0-25.705 1.21-44.115 9.336-10.526 4.643-19.994 10.921-28.14 18.66-9.712 9.221-17.624 20.59-23.512 33.796-8.623 19.336-6.576 51.905-4.932 78.078l.006.041c.176 2.803.361 5.73.53 8.582-1.265.581-3.316 1.194-6.339 1.194-4.864 0-10.648-1.555-17.187-4.619-1.924-.896-4.12-1.349-6.543-1.349-3.893 0-7.997 1.146-11.557 3.239-4.479 2.63-7.373 6.347-8.159 10.468-.518 2.726-.493 8.114 5.492 13.578 3.292 3.008 8.128 5.782 14.37 8.249 1.638.645 3.582 1.261 5.641 1.914 7.145 2.271 17.959 5.702 20.779 12.339 1.429 3.365.814 7.793-1.823 13.145-.069.146-.138.289-.201.439-.659 1.539-6.807 15.465-19.418 30.152-7.166 8.352-15.059 15.332-23.447 20.752-10.238 6.617-21.316 10.943-32.923 12.855a9.038 9.038 0 0 0-7.559 9.424c.078 1.33.39 2.656.931 3.939l.013.023c1.843 4.311 6.116 7.973 13.063 11.203 8.489 3.943 21.185 7.26 37.732 9.855.836 1.59 1.704 5.586 2.305 8.322.629 2.908 1.285 5.898 2.22 9.074 1.009 3.441 3.626 7.553 10.349 7.553 2.548 0 5.478-.574 8.871-1.232 4.969-.975 11.764-2.305 20.245-2.305 4.702 0 9.575.414 14.48 1.229 9.455 1.574 17.606 7.332 27.037 14 13.804 9.758 29.429 20.803 53.302 20.803.651 0 1.304-.021 1.949-.066.789.037 1.767.066 2.799.066 23.88 0 39.501-11.049 53.29-20.799l.022-.02c9.433-6.66 17.575-12.41 27.027-13.984 4.903-.814 9.775-1.229 14.479-1.229 8.102 0 14.517 1.033 20.245 2.15 3.738.736 6.643 1.09 8.872 1.09l.218.004h.226c4.917 0 8.53-2.699 9.909-7.422.916-3.109 1.57-6.029 2.215-8.986.562-2.564 1.46-6.674 2.296-8.281 16.558-2.6 29.249-5.91 37.739-9.852 6.931-3.215 11.199-6.873 13.053-11.166.556-1.287.881-2.621.954-3.979a9.036 9.036 0 0 0-7.56-9.424c-51.585-8.502-74.824-61.506-75.785-63.758a6.454 6.454 0 0 0-.205-.438c-2.637-5.354-3.246-9.777-1.816-13.148 2.814-6.631 13.621-10.062 20.771-12.332 2.07-.652 4.021-1.272 5.646-1.914 7.039-2.78 12.07-5.796 15.389-9.221 3.964-4.083 4.736-7.995 4.688-10.555-.121-6.194-4.856-11.698-12.388-14.393-2.544-1.052-5.445-1.607-8.399-1.607-2.011 0-4.989.276-7.808 1.592-6.035 2.824-11.441 4.368-16.082 4.588-2.468-.125-4.199-.66-5.32-1.171.141-2.416.297-4.898.458-7.486l.067-1.108c1.653-26.19 3.707-58.784-4.92-78.134-5.913-13.253-13.853-24.651-23.604-33.892-8.178-7.744-17.678-14.021-28.242-18.661-18.384-8.066-35.522-9.271-44.1-9.271"
        fill="#020202"
      />
      <path fill="none" d="M147.553 39.443h514.231v514.23H147.553z" />
    </svg>
  );
}

export function SvgIconLogoFacebook() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 408.788 408.788"
      style={{ enableBackground: "new 0 0 408.788 408.788" }}
    >
      <path
        style={{ fill: "#475993" }}
        d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085 h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882 v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955 l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087 c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085 C408.786,24.662,384.124,0,353.701,0z"
      />
    </svg>
  );
}

export function SvgIconLogoInstagram() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 551.034 551.034"
      style={{ enableBackground: "new 0 0 551.034 551.034" }}
    >
      <g>
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1="275.517"
          y1="4.57"
          x2="275.517"
          y2="549.72"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopcolor: "#E09B3D" }} />
          <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
          <stop offset="0.6" style={{ stopColor: "#C21975" }} />
          <stop offset="1" style={{ stopColor: "#7024C4" }} />
        </linearGradient>
        <path
          style={{ fill: "url(#SVGID_1_)" }}
          d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
        />

        <linearGradient
          id="SVGID_2_"
          gradientUnits="userSpaceOnUse"
          x1="275.517"
          y1="4.57"
          x2="275.517"
          y2="549.72"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopColor: "#E09B3D" }} />
          <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
          <stop offset="0.6" style={{ stopColor: "#C21975" }} />
          <stop offset="1" style={{ stopColor: "#7024C4" }} />
        </linearGradient>
        <path
          style={{ fill: "url(#SVGID_2_)" }}
          d="M275.517,133C196.933,133,133,196.933,133,275.516s63.933,142.517,142.517,142.517 S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6c-48.095,0-87.083-38.988-87.083-87.083 s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083C362.6,323.611,323.611,362.6,275.517,362.6z"
        />

        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1="418.31"
          y1="4.57"
          x2="418.31"
          y2="549.72"
          gradientTransform="matrix(1 0 0 -1 0 554)"
        >
          <stop offset="0" style={{ stopColor: "#E09B3D" }} />
          <stop offset="0.3" style={{ stopColor: "#C74C4D" }} />
          <stop offset="0.6" style={{ stopColor: "#C21975" }} />
          <stop offset="1" style={{ stopColor: "#7024C4" }} />
        </linearGradient>
        <circle
          style={{ fill: "url(#SVGID_3_)" }}
          cx="418.31"
          cy="134.07"
          r="34.15"
        />
      </g>
    </svg>
  );
}

export function SvgIconEmail() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 24.5"
      enableBackground="new 0 0 24.5 24.5"
    >
      <path
        fill="#8BBF3F"
        d="M16.2,4.5c-0.2,0-0.3,0-0.4-0.1l-3.6-2.7L8.6,4.4c-0.3,0.2-0.8,0.2-1-0.2c-0.2-0.3-0.2-0.8,0.2-1l4-3 C12,0,12.4,0,12.6,0.2l4,3c0.3,0.2,0.4,0.7,0.2,1C16.7,4.4,16.4,4.5,16.2,4.5z"
      />
      <path
        fill="#8BBF3F"
        d="M22.1,24.5H2.3c-1.2,0-2.2-1-2.2-2.2v-13C0,9,0.2,8.8,0.3,8.7l3-2.2c0.3-0.2,0.8-0.2,1,0.2 c0.2,0.3,0.2,0.8-0.2,1l-2.7,2v12.6c0,0.4,0.3,0.7,0.7,0.7h19.8c0.4,0,0.7-0.3,0.7-0.7V9.7l-3.2-2.4c-0.3-0.2-0.4-0.7-0.2-1 c0.2-0.3,0.7-0.4,1-0.2L24,8.7c0.2,0.1,0.3,0.4,0.3,0.6v13C24.3,23.5,23.3,24.5,22.1,24.5z"
      />
      <path
        fill="#8BBF3F"
        d="M12.2,19c-0.1,0-0.3,0-0.4-0.1L0.4,11.4c-0.3-0.2-0.4-0.7-0.2-1c0.2-0.3,0.7-0.4,1-0.2l11,7.2l11-7.2 c0.3-0.2,0.8-0.1,1,0.2c0.2,0.3,0.1,0.8-0.2,1l-11.4,7.5C12.5,19,12.3,19,12.2,19z"
      />
      <path
        fill="#8BBF3F"
        d="M3.8,20.5c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.3-0.2-0.8,0.2-1l5-3.5c0.3-0.2,0.8-0.2,1,0.2 c0.2,0.3,0.2,0.8-0.2,1l-5,3.5C4.1,20.5,3.9,20.5,3.8,20.5z"
      />
      <path
        fill="#8BBF3F"
        d="M20.6,20.5c-0.1,0-0.3,0-0.4-0.1l-5-3.5c-0.3-0.2-0.4-0.7-0.2-1c0.2-0.3,0.7-0.4,1-0.2l5,3.5 c0.3,0.2,0.4,0.7,0.2,1C21.1,20.4,20.9,20.5,20.6,20.5z"
      />
      <path
        fill="#8BBF3F"
        d="M20.1,13.5c-0.4,0-0.7-0.3-0.7-0.7V4.5H4.5v8.2c0,0.4-0.3,0.7-0.7,0.7S3,13.2,3,12.8v-9C3,3.4,3.3,3,3.8,3 h16.4c0.4,0,0.7,0.3,0.7,0.7v9C20.9,13.2,20.5,13.5,20.1,13.5z"
      />
      <path
        fill="#8BBF3F"
        d="M12.2,5.8c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5h0.1c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-0.1 c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4v0.9c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.5-0.3-0.6-0.6v-0.9 c0-1.2-1-2.2-2.2-2.3C11,8,10,9,9.9,10.3c0,1.2,1,2.2,2.2,2.3c0.5,0,1-0.2,1.4-0.5c0.4,0.8,1.5,1.1,2.3,0.6c0.5-0.3,0.9-0.9,0.9-1.5 v-0.9C16.7,7.8,14.7,5.8,12.2,5.8z M12.2,11.4c-0.6,0-1.1-0.5-1.1-1.2c0-0.6,0.5-1.2,1.1-1.2s1.1,0.5,1.1,1.2 C13.3,10.9,12.8,11.4,12.2,11.4z"
      />
    </svg>
  );
}

export function SvgIconText() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 20.5"
      enableBackground="new 0 0 24.5 20.5"
    >
      <path
        fill="#19ADE4"
        d="M3.8,20.5c-0.1,0-0.2,0-0.3-0.1C3.2,20.3,3,20.1,3,19.8v-3.2H1.8c-1,0-1.8-0.8-1.8-1.8v-13 C0,0.8,0.8,0,1.8,0h21c1,0,1.8,0.8,1.8,1.8v13c0,1-0.8,1.8-1.8,1.8H8.1l-3.8,3.8C4.1,20.4,3.9,20.5,3.8,20.5z M1.8,1.5 c-0.1,0-0.2,0.1-0.2,0.2v13c0,0.1,0.1,0.2,0.2,0.2h2c0.4,0,0.8,0.3,0.8,0.8v2.2l2.7-2.7C7.4,15.1,7.6,15,7.8,15h15 c0.1,0,0.2-0.1,0.2-0.2v-13c0-0.1-0.1-0.2-0.2-0.2H1.8z"
      />
      <path
        fill="#19ADE4"
        d="M8.8,9.5c-0.7,0-1.2-0.6-1.2-1.2S8.1,7,8.8,7S10,7.6,10,8.2S9.4,9.5,8.8,9.5z M8.8,8C8.6,8,8.5,8.1,8.5,8.2 s0.1,0.2,0.2,0.2S9,8.4,9,8.2S8.9,8,8.8,8z"
      />
      <path
        fill="#19ADE4"
        d="M16.8,9.5c-0.7,0-1.2-0.6-1.2-1.2S16.1,7,16.8,7S18,7.6,18,8.2S17.4,9.5,16.8,9.5z M16.8,8 c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2S17,8.4,17,8.2S16.9,8,16.8,8z"
      />
      <path
        fill="#19ADE4"
        d="M12.8,9.5c-0.7,0-1.2-0.6-1.2-1.2S12.1,7,12.8,7S14,7.6,14,8.2S13.4,9.5,12.8,9.5z M12.8,8 c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2S13,8.4,13,8.2S12.9,8,12.8,8z"
      />
    </svg>
  );
}

export function SvgIconBlocked() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.5 24.5"
      enableBackground="new 0 0 24.5 24.5"
    >
      <path
        fill="#F68929"
        d="M12.2,21c-4.8,0-8.7-3.9-8.7-8.7c0-4.8,3.9-8.7,8.7-8.7c4.8,0,8.7,3.9,8.7,8.7C20.9,17.1,17,21,12.2,21z M12.2,5.1c-4,0-7.2,3.2-7.2,7.2c0,4,3.2,7.2,7.2,7.2c4,0,7.2-3.2,7.2-7.2C19.4,8.3,16.2,5.1,12.2,5.1z"
      />
      <path
        fill="#F68929"
        d="M0.8,24.5c-0.2,0-0.4-0.1-0.5-0.2C0,24,0,23.5,0.3,23.2L23.1,0.3c0.3-0.3,0.8-0.3,1.1,0 c0.3,0.3,0.3,0.8,0,1.1L1.3,24.3C1.2,24.4,1,24.5,0.8,24.5z"
      />
    </svg>
  );
}

export function SvgLoadingEllipsis() {
  return (
    <svg
      style={{ position: "absolute", top: "-18px", left: 0 }}
      width="50px"
      height="50px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      className="lds-ellipsis"
    >
      <circle cx="84" cy="50" r="0" fill="#ff6633">
        <animate
          attributeName="r"
          values="10;0;0;0;0"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
        <animate
          attributeName="cx"
          values="84;84;84;84;84"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
      </circle>
      <circle
        cx="84"
        cy="50"
        r="0.909476"
        fill="rgba(100%,40%,19.999999999999996%,0.516)"
      >
        <animate
          attributeName="r"
          values="0;10;10;10;0"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="-1.5s"
        />
        <animate
          attributeName="cx"
          values="16;16;50;84;84"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="-1.5s"
        />
      </circle>
      <circle cx="80.9078" cy="50" r="10" fill="#00afea">
        <animate
          attributeName="r"
          values="0;10;10;10;0"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="-0.75s"
        />
        <animate
          attributeName="cx"
          values="16;16;50;84;84"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="-0.75s"
        />
      </circle>
      <circle
        cx="46.9078"
        cy="50"
        r="10"
        fill="rgba(0%,68.62745098039224%,91.76470588235294%,0.449)"
      >
        <animate
          attributeName="r"
          values="0;10;10;10;0"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
        <animate
          attributeName="cx"
          values="16;16;50;84;84"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
      </circle>
      <circle cx="16" cy="50" r="9.09052" fill="#ff6633">
        <animate
          attributeName="r"
          values="0;0;10;10;10"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
        <animate
          attributeName="cx"
          values="16;16;16;50;84"
          keyTimes="0;0.25;0.5;0.75;1"
          keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1"
          calcMode="spline"
          dur="3s"
          repeatCount="indefinite"
          begin="0s"
        />
      </circle>
    </svg>
  );
}

export function SvgNurse() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511.999 511.999"
      width="512"
      height="512"
    >
      <path
        d="M413.77 275.057c5.138-6.201 8.231-14.155 8.231-22.818 0-9.633-3.832-18.384-10.043-24.826l-4.725-123.841c-.877-22.823-11.895-44.015-29.801-57.882l5.204-11.49a7.506 7.506 0 0 0 .141-5.854 7.497 7.497 0 0 0-4.109-4.172c-77.958-32.231-167.381-32.231-245.339 0a7.5 7.5 0 0 0-3.968 10.026l5.205 11.49c-7.903 6.124-14.608 13.78-19.593 22.429a7.501 7.501 0 1 0 12.999 7.491c3.415-5.925 7.849-11.253 13.011-15.755 9.123 20.148 18.246 40.296 27.378 60.444a7.502 7.502 0 0 0 9.698 3.836c44.599-18.437 95.1-20.263 140.874-5.5a7.39 7.39 0 0 0-.657.533c-36.85 34.369-87.206 53.473-153.501 58.134a459 459 0 0 1-21.088.984h-.007a483.08 483.08 0 0 1-12.034.148 7.501 7.501 0 0 0 0 15.002c1.581 0 3.153-.014 4.721-.029v23.023h-10.552c-3.616 0-7.106.543-10.4 1.544l4.342-113.794a56.9 56.9 0 0 1 .149-2.47 7.502 7.502 0 0 0-6.83-8.117 7.497 7.497 0 0 0-8.117 6.83 71.938 71.938 0 0 0-.192 3.148l-4.725 123.839c-6.211 6.442-10.043 15.193-10.043 24.826 0 8.664 3.093 16.617 8.231 22.818l-.824 21.513c-.572 14.928 4.818 29.079 15.179 39.844 10.361 10.766 24.296 16.694 39.236 16.694h31.536a7.501 7.501 0 0 0 0-15.002h-31.536c-10.824 0-20.919-4.296-28.426-12.095-7.505-7.799-11.411-18.051-10.997-28.866l.441-11.532a35.556 35.556 0 0 0 11.302 2.4v8.278a7.501 7.501 0 0 0 15.002 0v-8.234h11.903c12.445 22.708 31.838 40.74 55.344 51.448v16.405h-3.331c-.429 0-.869.002-1.346.01l-.169.001-.045.002-.07.001c-.123.004-.245.013-.368.017-21.637.514-41.899 9.283-57.099 24.743-15.334 15.597-23.779 36.234-23.779 58.111v65.703a7.501 7.501 0 0 0 7.501 7.501h256.63a7.501 7.501 0 0 0 7.501-7.501v-65.703c0-21.877-8.445-42.514-23.779-58.111-14.781-15.034-34.351-23.726-55.286-24.668-.736-.037-1.483-.07-2.263-.096-.516-.012-1.031-.012-1.547-.012h-3.331v-2.801h54.571c14.941 0 28.875-5.929 39.237-16.694 10.36-10.765 15.75-24.916 15.179-39.844l-.826-21.509zm-274.627-2.006v-6.623a7.501 7.501 0 0 0-15.002 0v6.541C113.446 272.112 105 263.151 105 252.24c0-11.471 9.337-20.804 20.814-20.804h10.555c.013 1.961.076 3.913.181 5.856.017.309.038.617.057.925a123.274 123.274 0 0 0 .496 5.791c.023.209.042.419.066.627.12 1.035.254 2.068.4 3.098.036.256.078.51.116.765a121.595 121.595 0 0 0 .545 3.338c.135.756.278 1.509.427 2.261.055.28.108.561.166.84.209 1.015.429 2.026.665 3.035.034.144.071.287.105.431.206.866.422 1.73.648 2.591.082.315.168.629.253.943.195.718.396 1.435.604 2.149.09.31.179.62.272.929.267.89.544 1.776.832 2.661l.099.312c.324.983.664 1.961 1.014 2.937.102.285.209.568.314.852.156.424.307.849.468 1.272h-4.954zM392.24 104.146l4.344 113.83a35.703 35.703 0 0 0-10.4-1.544h-10.552v-15.27a42.14 42.14 0 0 0 4.721.277 7.501 7.501 0 0 0 0-15.002c-3.229 0-6.475-.587-9.671-1.753-11.754-4.252-21.928-15.573-29.143-28.979-5.06-9.403-8.662-19.829-10.325-29.567a79.666 79.666 0 0 1-.391-2.508 7.622 7.622 0 0 0-.168-.803c1.096.431 2.194.858 3.284 1.309a7.503 7.503 0 0 0 9.698-3.836 161227.9 161227.9 0 0 0 27.387-60.464c12.772 11.136 20.557 27.151 21.216 44.31zm-213.159 3.466a228143.6 228143.6 0 0 1-28.301-62.485l-4.511-9.959c70.171-26.899 149.286-26.899 219.457 0l-5.187 11.451c-9.206 20.331-18.413 40.662-27.625 60.992-49.272-18.434-104.559-18.434-153.833.001zm134.642 313.791c6.647-15.468 9.669-32.892 8.689-49.144 13.188 2.646 25.298 9.151 34.926 18.944 12.559 12.773 19.475 29.675 19.475 47.592v58.201H135.185v-58.201c0-17.917 6.916-34.82 19.475-47.592 9.625-9.789 21.729-16.292 34.926-18.942-.979 16.25 2.042 33.674 8.689 49.142 10.44 24.295 29.368 42.957 54.738 53.969a7.493 7.493 0 0 0 5.974 0c25.368-11.012 44.296-29.674 54.736-53.969zm-6.47-50.487c2.017 24.877-6.385 68.185-51.255 89.342-44.87-21.157-53.272-64.466-51.255-89.346h3.245c.01.037.022.074.031.111.065.248.14.492.208.738.128.457.255.913.395 1.364.088.282.184.56.276.84.135.41.271.819.417 1.224.105.291.216.578.326.866.095.248.182.5.281.747.055.137.117.271.173.408a53.008 53.008 0 0 0 1.27 2.834c.176.363.358.723.543 1.081.144.278.288.556.437.831.194.359.395.713.598 1.066.152.264.302.53.458.791.216.362.441.717.667 1.073.155.244.306.491.465.732.254.385.517.762.781 1.139.141.202.278.408.422.608a51.85 51.85 0 0 0 1.251 1.661c.054.069.111.135.166.204.39.49.787.973 1.195 1.447.165.192.338.378.506.567.299.338.599.675.907 1.005.198.211.402.416.603.624.289.298.579.596.876.887.217.213.439.421.66.629.291.275.584.549.881.817.231.208.464.412.699.615a47.279 47.279 0 0 0 1.632 1.356c.311.247.625.49.942.73.247.187.493.373.743.555.327.238.658.469.991.699.248.171.495.344.746.512.351.233.706.457 1.063.682.241.152.48.307.724.454.397.24.8.469 1.204.699.211.12.419.245.632.362a49.46 49.46 0 0 0 1.87.976c.038.019.077.036.115.054.6.295 1.208.578 1.821.849.223.098.451.188.675.283.431.183.862.365 1.298.536.265.104.534.199.802.298.403.15.806.298 1.214.438.286.098.574.189.862.281.396.127.793.252 1.193.37.298.088.598.17.899.252a47.735 47.735 0 0 0 3.333.787c.307.061.615.122.924.178.417.075.836.142 1.256.206.304.047.607.095.913.136.439.059.882.107 1.324.155.29.031.579.067.871.093.493.044.989.074 1.486.104.244.015.487.036.732.047.744.033 1.491.052 2.243.052 13.252 0 25.71-5.16 35.076-14.526a49.122 49.122 0 0 0 2.012-2.149c.141-.159.283-.317.422-.478a48.595 48.595 0 0 0 1.814-2.219c.095-.124.185-.25.278-.374a49.576 49.576 0 0 0 1.518-2.131c.095-.14.192-.278.285-.419a49.859 49.859 0 0 0 1.502-2.434c.101-.175.199-.352.298-.528.466-.827.915-1.663 1.333-2.516l.046-.089a50.15 50.15 0 0 0 1.201-2.678c.077-.185.154-.369.229-.555.362-.898.703-1.805 1.012-2.724.036-.108.068-.217.104-.325.284-.863.542-1.735.779-2.614.027-.1.062-.197.089-.297h3.267zm-85.861-12.546v-13.194c.065.02.131.036.196.055 1.224.368 2.453.714 3.688 1.041.277.074.554.143.831.215 1.105.285 2.214.555 3.328.808.186.042.37.088.556.129 1.25.277 2.505.531 3.765.768.292.055.585.107.877.16 1.155.208 2.314.402 3.477.576.144.022.287.047.431.068 1.273.186 2.552.346 3.834.491.304.034.609.066.914.099 1.222.129 2.446.243 3.675.335l.252.021a119.923 119.923 0 0 0 4.844.246c1.31.042 2.622.071 3.94.071a122.902 122.902 0 0 0 4.888-.105c1.302-.052 2.602-.118 3.896-.212.084-.006.168-.015.253-.021 1.228-.091 2.453-.206 3.675-.335.304-.032.608-.064.911-.098 1.283-.145 2.563-.305 3.838-.492.14-.02.279-.045.419-.066 1.169-.175 2.333-.37 3.496-.58.287-.052.574-.103.86-.156 1.263-.238 2.523-.492 3.777-.77.178-.039.355-.083.533-.124 1.124-.255 2.244-.528 3.361-.816.269-.069.538-.137.806-.208 1.24-.329 2.476-.677 3.706-1.046.063-.019.126-.034.189-.053v13.193c0 1.401-.083 2.794-.247 4.15-.915 7.646-4.425 14.857-9.888 20.312-6.536 6.536-15.227 10.136-24.472 10.136-2.189 0-4.337-.204-6.421-.596-14.591-2.744-26.126-14.664-27.939-29.864a33.9 33.9 0 0 1-.249-4.138zm73.89-30.747c-12.465 5.063-25.683 7.63-39.286 7.63-1.7 0-3.395-.04-5.082-.12-.921-.044-1.839-.102-2.756-.169a103.517 103.517 0 0 1-31.448-7.341h-.001l-.005-.002c-23.672-9.589-43-27.492-54.422-50.412-7.242-14.533-10.915-30.207-10.915-46.584v-37.568c1.481-.058 2.946-.132 4.413-.202.717-.034 1.443-.061 2.158-.099 2.221-.117 4.426-.249 6.615-.397.7-.047 1.388-.105 2.084-.156 1.488-.107 2.979-.213 4.452-.335.938-.077 1.862-.168 2.794-.251 1.219-.109 2.443-.213 3.652-.331.985-.097 1.956-.206 2.934-.309 1.14-.12 2.284-.236 3.416-.365 1.005-.115 1.998-.242 2.997-.364 1.085-.132 2.175-.261 3.252-.402 1.015-.133 2.018-.277 3.026-.417 1.045-.145 2.093-.287 3.13-.44 1.009-.149 2.006-.309 3.008-.466 1.021-.16 2.044-.317 3.058-.485 1-.166 1.989-.342 2.983-.515.996-.174 1.994-.346 2.982-.527.992-.182 1.973-.374 2.958-.564.975-.188 1.952-.375 2.92-.572.977-.198 1.946-.405 2.916-.611.957-.203 1.915-.406 2.865-.617.966-.215 1.924-.438 2.883-.66.937-.218 1.874-.435 2.804-.66.953-.231 1.898-.469 2.844-.708.921-.233 1.84-.466 2.754-.707.937-.246 1.867-.5 2.796-.754.907-.249 1.812-.499 2.713-.755.919-.262 1.832-.529 2.744-.799.894-.264 1.785-.531 2.672-.803a273.935 273.935 0 0 0 7.973-2.587 262.305 262.305 0 0 0 7.734-2.785c.851-.322 1.7-.648 2.544-.978.842-.33 1.68-.665 2.516-1.003.833-.337 1.664-.675 2.49-1.02.831-.347 1.655-.7 2.478-1.055.814-.351 1.628-.703 2.435-1.062.821-.365 1.635-.737 2.448-1.11a215.2 215.2 0 0 0 2.376-1.101c.812-.384 1.616-.775 2.42-1.167.775-.378 1.551-.754 2.318-1.139.802-.402 1.596-.814 2.391-1.225.755-.39 1.511-.778 2.259-1.176.796-.423 1.583-.856 2.371-1.288.732-.401 1.466-.799 2.191-1.207.794-.447 1.578-.905 2.364-1.36.705-.409 1.412-.814 2.11-1.229.791-.471 1.572-.954 2.355-1.434.68-.417 1.364-.83 2.038-1.254.793-.499 1.574-1.01 2.358-1.518.649-.42 1.302-.835 1.945-1.262.805-.535 1.598-1.083 2.394-1.628.609-.417 1.224-.828 1.828-1.251.831-.582 1.649-1.179 2.47-1.772.555-.401 1.117-.795 1.667-1.202.912-.674 1.81-1.364 2.711-2.052.446-.341.9-.674 1.343-1.019a201.872 201.872 0 0 0 3.972-3.169c.21.756.429 1.513.657 2.271.078.261.163.522.243.783.154.498.307.996.468 1.494.1.31.206.619.309.929.15.45.299.899.455 1.349.115.333.235.665.354.997.152.426.304.853.462 1.279.128.345.259.689.39 1.033a104.018 104.018 0 0 0 .899 2.29 115.211 115.211 0 0 0 1.947 4.539c.177.389.357.778.539 1.166.168.358.335.717.507 1.074.184.383.372.764.56 1.145.178.36.355.719.536 1.078.189.373.383.744.576 1.115.188.361.374.721.565 1.08.195.365.396.727.595 1.09.198.361.394.723.596 1.081.196.347.397.69.597 1.035.213.368.423.739.639 1.104.147.248.299.491.448.737.51.844 1.031 1.679 1.563 2.505.178.277.353.556.533.831.259.394.524.781.788 1.17.192.283.381.569.576.85.266.384.538.763.809 1.142.199.278.396.558.597.834.275.377.555.749.835 1.12.204.271.407.542.613.81.285.37.574.735.864 1.1a82.207 82.207 0 0 0 3.725 4.384c.316.347.634.692.955 1.033.214.227.431.451.647.676.33.342.661.682.996 1.017.211.21.424.416.637.623.347.338.693.675 1.045 1.005.203.19.409.375.613.562a74.1 74.1 0 0 0 1.108 1.001c.179.157.361.307.541.462.404.347.808.695 1.219 1.031.088.072.178.14.266.211a61.858 61.858 0 0 0 4.572 3.369c.178.119.354.243.534.36.388.253.781.492 1.173.734.247.152.492.309.741.457.368.219.74.427 1.111.636.28.158.56.319.842.471.355.192.714.374 1.072.557.206.105.41.218.617.321v33.946a106.3 106.3 0 0 1-1.073 15.135c-1.571 10.928-4.863 21.458-9.842 31.45l-.002.005c-11.418 22.918-30.745 40.82-54.424 50.413zm93.323-1.613c-7.506 7.799-17.601 12.095-28.426 12.095h-51.663a119.676 119.676 0 0 0 52.436-50.05h11.902v8.235a7.501 7.501 0 0 0 15.002 0v-8.278a35.577 35.577 0 0 0 11.302-2.4l.441 11.532c.418 10.816-3.488 21.068-10.994 28.866zm-.748-53.042v-6.541a7.5 7.5 0 1 0-15.002 0v6.625h-4.956c.158-.415.306-.832.459-1.248.109-.296.22-.591.326-.887.348-.97.686-1.942 1.008-2.92.039-.118.074-.237.113-.355.283-.869.556-1.742.819-2.618.094-.313.185-.628.276-.942.207-.71.407-1.422.6-2.135.086-.318.173-.637.257-.955.224-.855.438-1.713.643-2.573.035-.149.074-.297.109-.447.235-1.007.455-2.018.664-3.033.058-.279.11-.56.166-.84a123.3 123.3 0 0 0 .6-3.256c.132-.777.255-1.556.371-2.337.039-.258.08-.516.117-.775.146-1.029.28-2.06.4-3.095.024-.208.043-.417.066-.624.092-.837.176-1.675.251-2.516.029-.331.056-.662.083-.993.061-.76.115-1.522.162-2.286.019-.308.04-.616.057-.925.105-1.943.168-3.895.181-5.856h10.555c11.477 0 20.814 9.333 20.814 20.804.002 10.911-8.444 19.871-19.139 20.728z"
        fill="#656766"
      />
      <path
        d="M287.941 260.261a7.5 7.5 0 0 0-10.437 1.897 26.17 26.17 0 0 1-21.505 11.28 26.168 26.168 0 0 1-21.504-11.28 7.501 7.501 0 1 0-12.334 8.541A41.173 41.173 0 0 0 256 288.441a41.174 41.174 0 0 0 33.84-17.742 7.505 7.505 0 0 0-1.899-10.438zM310.333 209.904a7.501 7.501 0 0 0-7.501 7.501v2a7.501 7.501 0 0 0 15.002 0v-2a7.5 7.5 0 0 0-7.501-7.501zM201.664 209.904a7.501 7.501 0 0 0-7.501 7.501v2a7.501 7.501 0 0 0 15.002 0v-2a7.5 7.5 0 0 0-7.501-7.501zM270.696 44.603H263.5v-7.196a7.501 7.501 0 0 0-15.002 0v7.196h-7.196a7.501 7.501 0 0 0 0 15.002h7.196v7.196a7.501 7.501 0 0 0 15.002 0v-7.196h7.196a7.501 7.501 0 0 0 0-15.002z"
        fill="#656766"
      />
    </svg>
  );
}

export function SvgLocations() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 370.9 512">
      <path
        fill="#666"
        d="M185.4 0C83.2 0 0 83.2 0 185.4c0 126.9 165.9 313.2 173 321 6.6 7.4 18.2 7.4 24.8 0 7.1-7.9 173-194.1 173-321C370.9 83.2 287.7 0 185.4 0zm0 278.7c-51.4 0-93.3-41.9-93.3-93.3s41.9-93.3 93.3-93.3 93.3 41.9 93.3 93.3-41.8 93.3-93.3 93.3z"
      />
    </svg>
  );
}
